<terra-main-nav [showNav]="false" [showAccountActions]="false"></terra-main-nav>

<section class="container-small" *ngIf="{ isCodeSent: isCodeSent$ | async, phoneMasked: phoneMasked$ | async } as data">
  <h1>Two-factor authentication</h1>
  <ng-template #pageLoader>
    <terra-loader></terra-loader>
  </ng-template>
  <ng-container *ngIf="data.isCodeSent && data.phoneMasked; else pageLoader">
    <p class="description">We sent a verification to your number ending in {{ data.phoneMasked }}</p>
    <form class="form terra-error-style" [formGroup]="pageForm" (ngSubmit)="submit()">
      <p class="description">
        Enter the 6-digit verification code:
      </p>
      <!-- two factor code  -->
      <mat-form-field appearance="outline" class="input-width">
        <input matInput placeholder="Verification Code" formControlName="twoFactorCode" />
        <mat-error *ngIf="pageForm.get('twoFactorCode').hasError('required')"> Code is required </mat-error>
        <mat-error *ngIf="pageForm.get('twoFactorCode').hasError('minlength') || pageForm.get('twoFactorCode').hasError('maxlength')"> Code must be 6 characters </mat-error>
        <mat-error *ngIf="pageForm.get('twoFactorCode').hasError('codeMismatch')"> Wrong code, please try again </mat-error>
      </mat-form-field>

      <p class="resend-code-text">Didn’t receive a code? <a class="light link resend-code-link" (click)="resendCode()">Resend code</a></p>

      <!-- save device  -->
      <div class="terra-form-field-wrapper">
        <mat-checkbox color="primary" formControlName="saveDevice" class="regular-checkbox is-organization-checkbox">
          Don't ask again on this device for next 30 days
        </mat-checkbox>
      </div>

      <!-- Continute -->
      <button type="submit" mat-flat-button class="submit-button tall-button" color="primary" [disabled]="formSubmitting">
        Submit
      </button>
    </form>
  </ng-container>

  <ul class="footer-links">
    <li class="footer-li">
      <a mat-button class="footer-link" routerLink="/logout"><mat-icon class="footer-link-icon notranslate">keyboard_backspace</mat-icon>Back to login</a>
    </li>
    <li class="footer-li">
      <a target="_blank" mat-button class="footer-link" href="//www.covercy.com/contact-us">
        <mat-icon class="footer-link-icon notranslate">question_answer</mat-icon>
        Covercy contact details
      </a>
    </li>
  </ul>
</section>
